function escapeHtml(s) {
  if (s == null) return '';
  const str = String(s);
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/** Convert HTML to readable plain text (block elements → newlines, links → "text (url)"). */
export function htmlToReadableText(html) {
  if (!html || typeof html !== 'string') return '';
  let s = html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '')
    .replace(/<head\b[^<]*(?:(?!<\/head>)<[^<]*)*<\/head>/gi, '');
  s = s.replace(/<li[^>]*>/gi, '\n• ');
  s = s.replace(/<\/?(?:p|div|h[1-6]|li|tr|br)[^>]*>/gi, '\n');
  s = s.replace(/<\/?(?:ul|ol|table|tbody|thead|hr)[^>]*>/gi, '\n');
  s = s.replace(/<a\s[^>]*href\s*=\s*["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/gi, (_m, url, text) => {
    const t = (text || '').replace(/<[^>]+>/g, '').trim();
    return t ? `${t} (${url})` : url;
  });
  s = s.replace(/<[^>]+>/g, '');
  s = s.replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"');
  s = s.replace(/\n\s*\n\s*\n/g, '\n\n').trim();
  return s;
}

/** Wrap plain text (with merge tokens) in a minimal HTML shell for one editor + HTML sends. */
export function plainTextToEmailHtml(text) {
  if (text == null || String(text).trim() === '') return '';
  const normalized = String(text).replace(/\r\n/g, '\n');
  const escaped = escapeHtml(normalized);
  return `<div style="white-space:pre-wrap;font-family:Arial,sans-serif;font-size:14px;line-height:1.5;">${escaped}</div>`;
}

/**
 * Admin draft: always edit body as HTML. Legacy text-only docs hydrate into bodyHtmlTemplate.
 */
export function unifyTemplateForAdminDraft(record) {
  if (!record) return null;
  const html = (record.bodyHtmlTemplate || '').trim();
  const plain = record.bodyTextTemplate || '';
  const bodyHtmlTemplate = html || plainTextToEmailHtml(plain);
  return {
    ...record,
    format: 'html',
    bodyHtmlTemplate,
    bodyTextTemplate: plain,
  };
}
